import T from 'ramda/es/T'
import cond from 'ramda/es/cond'
import always from 'ramda/es/always'
import React, { PureComponent } from 'react'
import { Button } from '@material-ui/core'

import { currencyMaker } from 'services/helpers'
import { Tooltip } from 'components'

class RouteButtonBase extends PureComponent {
  state = {
    disabled: false,
    price: null,
    time: null,
    tooltip: false
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      disabled: getRouteDisabled(nextProps),
      price: nextProps.citiesRoutePrice[nextProps.route.id] || null,
      time: nextProps.departureTime[nextProps.route.id] || null
    }
  }

  showTooltip = () => {
    const { price, time } = this.state

    if (price && time) {
      this.setState({ tooltip: true })
    }
  }

  hideTooltip = () => {
    this.setState({ tooltip: false })
  }

  render() {
    const { route, children, routeId, selectRoute } = this.props
    const { disabled, price, tooltip, time } = this.state

    const { id } = route
    const variant = id === routeId ? 'contained' : 'text'
    const tooltipTitle = `Ціна: ${price} ${currencyMaker(this.props.fromCityType)}. Відправлення: ${time}`

    return (
      <Tooltip
        open={tooltip}
        title={tooltipTitle}
        onOpen={this.showTooltip}
        onClose={this.hideTooltip}
      >
        <Button
          color='primary'
          variant={variant}
          disabled={Boolean(disabled)}
          onClick={() => selectRoute(route)}
          className={this.props.classes.button}
        >
          {children}
        </Button>
      </Tooltip>
    )
  }
}

function getRouteDisabled({ routeId, shownRoutes, route, date, isAlimanDispatcher }) {
  if (route.isDeveloping) {
    return true
  }

  if (isAlimanDispatcher) {
    function handleRouteFromUa() {
      return route.type !== "ua"
    }

    function handleRouteFromCz() {
      return route.type !== "cz"
    }

    return cond([
      [isDateFromUa, handleRouteFromUa],
      [isDateFromCz, handleRouteFromCz],
      [T, always(true)],
    ])(date)
  }

  return Boolean(!routeId && shownRoutes.length && !shownRoutes.includes(route.id))
}

function isDateFromUa(date) {
  return date.getDay() === 4 || date.getDay() === 5
}

function isDateFromCz(date) {
  return date.getDay() === 6 || date.getDay() === 0
}

export {
  RouteButtonBase
}



// WEBPACK FOOTER //
// ./src/components/RouteButton/RouteButton.js